var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCommonIconMegaphoneFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47 6c-1.652 0-3 1.348-3 3v32c0 1.652 1.348 3 3 3s3-1.348 3-3V9c0-1.652-1.348-3-3-3zm-5 2.844L8 19.063v10.062l5.656 1.969-.781 2.062v.032c-.773 2.32.496 4.851 2.813 5.624l4.156 1.407a4.46 4.46 0 005.625-2.813l.656-1.937L42 41zM3 18c-1.652 0-3 1.348-3 3v6c0 1.652 1.348 3 3 3s3-1.348 3-3v-6c0-1.652-1.348-3-3-3zm12.531 13.75l8.688 3.031-.657 1.969a2.432 2.432 0 01-3.093 1.563l-4.157-1.376c-1.28-.43-1.94-1.804-1.53-3.093.003-.012-.005-.02 0-.032z"
  })));
}

export default SvgCommonIconMegaphoneFilled;